"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RatingsCountModule = _interopRequireDefault(require("./RatingsCount.module.css"));
var _Star = _interopRequireDefault(require("./Star"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RatingsCount = _ref => {
  let {
    ratingGiven,
    totalRating
  } = _ref;
  const parsedRating = !ratingGiven || isNaN(parseFloat(ratingGiven).toFixed(1)) ? null : ratingGiven;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _RatingsCountModule.default.starRatingContainer
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _RatingsCountModule.default.starContainer
  }, [...Array(5)].map((_, index) => /*#__PURE__*/_react.default.createElement(_Star.default, {
    key: index,
    className: (0, _classnames.default)(index + 1 <= parsedRating && _RatingsCountModule.default.active)
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: _RatingsCountModule.default.ratedCount
  }, parsedRating, " (", totalRating ? `${totalRating}` : 0, ")"));
};
RatingsCount.propTypes = {
  ratingGiven: _propTypes.default.number,
  totalRating: _propTypes.default.number
};
var _default = exports.default = RatingsCount;